import { SLIP, type SlipKey } from "./slip-manifest";

/** Fixed display copy set in Slipstream, drawn as a CSS mask over `currentColor`.
 *
 *  The outlines live in public/slip/{key}.svg (generated by scripts/gen-slipstream.mjs —
 *  don't hand-edit). A mask rather than an <img> keeps the colour and glow on theme
 *  tokens, so it follows light/dark like text does. Sized in `em`: set font-size (and
 *  color) on the element exactly as you would for text. The accessible name is the copy. */
export function Slip({ k, className = "" }: { k: SlipKey; className?: string }) {
  const { text, aspect } = SLIP[k];
  // The mask carries no text, so a PDF of the page (the resume) would have no name in
  // it for an ATS to parse. The copy rides along as a real, invisible text layer.
  return (
    <span className={`slip-wrap ${className}`} style={{ width: `calc(var(--slip-h) * ${aspect})` }}>
      <span
        role="img"
        aria-label={text}
        className="slip"
        style={{
          WebkitMaskImage: `url(/slip/${k}.svg)`,
          maskImage: `url(/slip/${k}.svg)`,
        }}
      />
      <span className="slip-text" aria-hidden="true">
        {text}
      </span>
    </span>
  );
}
